module.exports = __webpack_public_path__ + "img/info-en.361af90e.jpg";